export default __webpack_public_path__ + "static/media/trail.ae2d9675.jpg";